import Store from "store"
import { SharedModalConfirmActionShow } from "store/actions"

const onConfirmDelete = function(selected) {
  this.collection.delete.selected = selected
  const users = Store.getState().Users.collection
  const user = users.find((u) => u.id === selected.id)
  Store.dispatch(
    SharedModalConfirmActionShow(
      `User "${user.full_name}" will be removed. Are you sure?`,
      this.collection.delete
    )
  )
}
export default onConfirmDelete